import { SystemStyleObject } from '@chakra-ui/react';

export const baseSx: SystemStyleObject = {
  py: [8, 12],
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderStyle: 'dashed',
  borderWidth: '1px',
  borderRadius: 6,
  borderColor: 'M.40',
  bg: 'surface2',
  outline: 'none',
  width: '100%',
  maxWidth: '1200px',
  maxHeight: 'calc(100vh - 115px)',
  height: 500,
  overflow: 'auto',
  '@media screen and (max-height: 700px)': {
    marginTop: '90px',
  },
};

export const closeBtnSx: SystemStyleObject = {
  size: 'xl',
  height: 12,
  width: 12,
  right: 10,
  top: 10,
  bg: 'M.30',
  color: 'textSubdued',
  _hover: {
    color: 'textBase',
  },
  borderRadius: '50%',
  outline: 'none',
};

export const activeSx: SystemStyleObject = {
  borderColor: 'B.0',
  borderStyle: 'solid',
};

export const acceptSx: SystemStyleObject = {
  borderColor: 'B.0',
  borderStyle: 'solid',
};

export const rejectSx: SystemStyleObject = {
  borderColor: 'borderWarning',
  borderStyle: 'solid',
};
